import React, { useEffect, useState } from "react";

interface QuestionData {
    sentence: string;
    correctNoun: string;
}

import { IonItem, IonLabel, IonRadio, IonRadioGroup } from "@ionic/react";

const NounsPickup: React.FC = () => {
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [isComplete, setIsComplete] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [words, setWords] = useState<string[]>([]);
    const [currentQuestion, setCurrentQuestion] = useState([]);

    const handleSubmit = (userInput: string) => {
        if (questions.length === 0) return;
        setSelectedOption(userInput);

        const correctAnswer = questions[currentIndex]?.correctNoun;
        if (userInput === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    setWords(questions[nextIndex].sentence.split(" "));
                } else {
                    setIsComplete(true);
                }
                setShowImage(false);
                setError(false);
            }, 5000); // Shortened delay to 3 seconds
        } else {
            setError(true);
        }
    };

    function shuffleArray(array: any[]) {
        for (let i = array.length - 1; i > 0; i--) {
            // Generate a random index
            const randomIndex = Math.floor(Math.random() * (i + 1));
            // Swap elements
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    }

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'NounsProblem.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/NounsProblem.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
            const myQuestion = (shuffledQuestions[currentIndex]?.sentence.split("."));
            setWords(myQuestion[0].split(" ") || []);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };


    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - English - Noun – Naming Words - Pickup Nouns"; // Set page title
    }, []);

    return (
        <>
            {
                showImage === false ?
                    <>
                        <div className="contentPart englishStory additionWord">
                            <div className="mb-4">
                                <h2>{`Select the noun in the sentence`}</h2>
                                <p style={{ fontSize: '20px' }}>{questions[currentIndex]?.sentence}</p>
                            </div>
                            <div className="grid-container" style={{marginBottom: "20px"}}>
                                <div className="grid-box d-none d-lg-block"></div>
                                <div className="grid-box optionDiv" style={{display: "block"}}>
                                    <IonRadioGroup onIonChange={(e) => handleSubmit(e.detail.value)}>
                                        {words.map((word, index) => (
                                            <IonItem key={index} className={`${selectedOption === word
                                                ? word === questions[currentIndex]?.correctNoun
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                                }`}>
                                                <IonLabel>{word}</IonLabel>
                                                <IonRadio slot="start" value={word} />
                                            </IonItem>
                                        ))}
                                    </IonRadioGroup>
                                </div>
                                <div className="grid-box d-none d-lg-block"></div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default NounsPickup;

